import { ComponentProps, forwardRef } from "react"

import { cn } from "@/lib/utils"

import * as Section from "./Section"

export interface BaseSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  children: React.ReactNode
}

export const Root = Section.Root

export const Header = forwardRef(function Header(
  {
    className,
    children,
    bg = "haze",
    ...props
  }: BaseSectionProps & { bg?: "white" | "haze" },
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <Section.Header ref={ref} className={cn("p-5", className)} bg={bg} {...props}>
      {children}
    </Section.Header>
  )
})

export const Title = forwardRef(function Title(
  { className, children, ...props }: ComponentProps<"span">,
  ref: React.Ref<HTMLHeadingElement>,
) {
  return (
    <span
      ref={ref}
      className={cn("row-start-1 text-h2 text-colors-text-primary", className)}
      {...props}
    >
      {children}
    </span>
  )
})

export const Subtitle = forwardRef(function Subtitle(
  { className, children, ...props }: ComponentProps<"span">,
  ref: React.Ref<HTMLHeadingElement>,
) {
  return (
    <span
      ref={ref}
      className={cn("row-start-2 text-body1 text-colors-text-tertiary", className)}
      {...props}
    >
      {children}
    </span>
  )
})

export const Body = forwardRef(function Body(
  { className, children, ...props }: BaseSectionProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <Section.Body ref={ref} className={cn("bg-transparent", className)} {...props}>
      {children}
    </Section.Body>
  )
})

export const Actions = Section.Actions
